import { useState, useEffect } from 'react';
import {
    isStandalone,
    isWeb,
    getDisplayMode,
    addDisplayModeListener,
    supportsAddToHomeScreen
} from '../platform/runtime';

/**
 * React hook to detect if the app is running as a PWA (standalone mode)
 * @returns {Object} Object containing PWA status information
 */
export const usePWAStatus = () => {
    const [isPWA, setIsPWA] = useState(isStandalone());
    const [displayMode, setDisplayMode] = useState(getDisplayMode());
    
    useEffect(() => {
        // Listen for display mode changes
        const cleanup = addDisplayModeListener((newDisplayMode) => {
            setDisplayMode(newDisplayMode);
            setIsPWA(newDisplayMode === 'standalone' || newDisplayMode === 'fullscreen');
        });
        
        return cleanup;
    }, []);
    
    return {
        isPWA,
        displayMode,
        isStandalone: isPWA,
        isBrowser: isWeb() && !isPWA
    };
};

/**
 * React hook to detect if the current device/browser supports adding to home screen
 * @returns {boolean} true if supported, false otherwise
 */
export const useAddToHomeScreenSupport = () => {
    const [isSupported, setIsSupported] = useState(supportsAddToHomeScreen());
    
    useEffect(() => {
        setIsSupported(supportsAddToHomeScreen());
    }, []);
    
    return isSupported;
};
